import { Component } from '@angular/core';
import { AjaxService } from '../services/ajax.service';
import { Utility } from '../shared/utility/utility';
import { EmitterService } from '../services/emitter.service';

@Component({
  selector: 'app-cool-off',
  templateUrl: './cool-off.component.html',
  styleUrl: './cool-off.component.scss'
})
export class CoolOffComponent {
  coolOffPoints = [
    'coolOffModalComp.point1',
    'coolOffModalComp.point2',
    'coolOffModalComp.point3'
  ];
  constructor(
    private utils: Utility,
    private ajaxService: AjaxService,
    private emitterService: EmitterService
  ) { }

  closeCoolOffModal(): void {
    this.utils.closeModal('coolOffModal');
  }

  confirmCoolOff(): void {

    const data = {
      rgCoolOffPeriodInDays: '1',
      reason: 'Cool Off',
      rgClose: 'false',
      type: 'COOL_OFF',
      rgDuration: 24,
      periodUnit: 'HOURS'
    };

    this.ajaxService.suspendAccount(data)
      .then((response: any) => {
        if (response?.success) {
          this.closeCoolOffModal();
          this.emitterService.broadcastlogoutComplete('userLoggedOff');
        } else {
          console.error('Cool Off failed:', response);
        }
      })
      .catch((error) => {
        console.error('Cool Off API error:', error);
      });
  }
}